import {
  LoggerImpInterface
} from './logger.imp.interface';

/**
 *
 * @class LoggerImp
 *
 * @brief a standard implementation of logger
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2019
 *
 */
export class LoggerImp implements LoggerImpInterface {

  /** @brief standard constructor */
  constructor() {

  }

  /** @brief standard logging interface */
  log(...args: any[]) {

    console.log(...args);
  }
}
